<div class="navbar-wrapper sticky top-0 z-[1000] w-full rounded-none border-none bg-[var(--p-menubar-background,var(--p-surface-0))] shadow-none relative after:content-[''] after:absolute after:left-0 after:right-0 after:bottom-0 after:h-px after:w-full after:rounded-none after:bg-[var(--p-surface-border,#dee2e6)] after:pointer-events-none">
    <p-menubar [model]="items">
        <ng-template pTemplate="start">
            <a routerLink="/dashboard" class="flex items-center mr-6 cursor-pointer hover:opacity-80 transition-opacity">
                <img src="assets/img/icon.png" height="25" width="auto" style="object-fit: contain; max-height: 25px;" alt="HONESTY CRM" />
            </a>
        </ng-template>
        <ng-template pTemplate="item" let-item>
            @if(item.label) {
                <a [routerLink]="item.route" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                    class="p-menuitem-link">
                    <span [class]="item.icon"></span>
                    <span>{{ item.label }}</span>
                    @if(item.items) {
                        <span class="pi pi-fw pi-angle-down ml-2"></span>
                    }
                </a>
            }
        </ng-template>
        <ng-template pTemplate="end">
            <div class="inline-flex items-center gap-2">
                <app-global-search (search)="onGlobalSearch($event)"></app-global-search>
                <app-notifications></app-notifications>
                <div class="profile-menu-container relative inline-block">
                    <button
                        type="button"
                        #profileMenuButton
                        class="p-0 border-none bg-transparent cursor-pointer"
                        (click)="toggleProfileMenu($event)"
                    >
                        @if (profileUser()) {
                            <app-user-avatar
                                [userId]="profileUser()?.id || profileUser()?.userID"
                                [displayName]="((profileUser()?.firstName || '') + ' ' + (profileUser()?.lastName || '')).trim()"
                                size="2rem"
                            />
                        } @else if (!profileLoaded()) {
                            <span class="h-8 w-8 shrink-0 rounded-full bg-slate-200/80 animate-pulse"></span>
                        } @else {
                            <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[var(--p-surface-200)]"><i class="pi pi-user text-base [color:var(--p-text-color-secondary)]"></i></span>
                        }
                    </button>
                    @if (profileMenuOpen()) {
                        <div class="profile-menu-dropdown" (click)="$event.stopPropagation()">
                            <ul class="p-submenu-list">
                                <li class="p-menuitem">
                                    <a class="p-menuitem-link" (click)="navigateToProfile(); $event.stopPropagation()">
                                        <span class="p-menuitem-icon pi pi-user"></span>
                                        <span class="p-menuitem-text">Profile</span>
                                    </a>
                                </li>
                                <li class="p-menuitem">
                                    <a class="p-menuitem-link" (click)="handleLogout(); $event.stopPropagation()">
                                        <span class="p-menuitem-icon pi pi-power-off"></span>
                                        <span class="p-menuitem-text">Logout</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    }
                </div>
            </div>
        </ng-template>
    </p-menubar>
</div>
